import { motion } from 'framer-motion'
import React, { useRef } from 'react'

const HarmonicaItem = ({
  item,
  index,
  activeIndex,
  onToggle,
  onMouseEnter,
  onMouseLeave,
}) => {
  const isOpen = index === activeIndex
  const hideBorder = activeIndex === index + 1
  const ref = useRef()

  return (
    <div
      ref={ref}
      className={`px-5 sm:px-7 md:px-8 lg:px-10 group transition ${
        isOpen && 'bg-white'
      } ${!isOpen && ''}`}
    >
      <div
        className={`border-b transition ${
          isOpen ? 'border-transparent' : 'border-gray-4'
        } ${index === 0 && 'border-t'} ${hideBorder && 'border-b-transparent'}`}
      >
        <button
          type="button"
          className={`py-5.5 flex items-center justify-between text-left w-full px-3 text-base font-bold ${
            !isOpen && 'group-hover:text-red'
          } transition`}
          onClick={onToggle}
          onMouseEnter={() => onMouseEnter(ref.current)}
          onMouseLeave={() => onMouseLeave(ref.current)}
        >
          <span>{item.itemTitle}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 22 22"
          >
            {isOpen ? (
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="2"
                d="M3 11h16"
              ></path>
            ) : (
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 3v8H3M19 11h-8v8"
              ></path>
            )}
          </svg>
        </button>
        <div className="overflow-hidden">
          <motion.div
            animate={{ height: isOpen ? 'auto' : 0 }}
            transition={{ type: 'ease' }}
          >
            <div
              className="max-w-full px-3 pt-1 prose u-p pb-9 lg:pr-16 link-wrapper"
              dangerouslySetInnerHTML={{ __html: item.body }}
            />

            {item.image[0] && (
              <div className="mt-3 mb-16">
                <div className="column-indent-both">
                  <img
                    src={item.image[0].url}
                    alt=""
                    className="w-full h-auto shadow-tpmp rounded-[5px]"
                  />
                </div>
              </div>
            )}

            {item.youtubeId && (
              <div className="mt-3 mb-16">
                <div className="column-indent-both">
                  <iframe
                    title={item.itemTitle}
                    src={`https://www.youtube.com/embed/${item.youtubeId}?modestbranding=1&rel=0`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full aspect-video rounded-[5px] shadow-tpmp"
                  ></iframe>
                </div>
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default HarmonicaItem
